import { Logger } from '@getgo/goto-logger'

import { RESTRICTED_LOGGER_KEYS } from './constants'
import getLogger from './logger'

let loggerInstance: Logger

export interface Measure {
  measureName: string
  duration: number
  details?: object
}

export class GTALogger {
  constructor() {
    if (loggerInstance) {
      throw new Error('New instance of GTA Logger cannot be created')
    }
    loggerInstance = getLogger()
  }

  info(message: any) {
    loggerInstance.info(message)
  }

  warn(message: any) {
    loggerInstance.warn(message)
  }

  error(message: any) {
    loggerInstance.error(message)
  }

  setAccountContext(accountKey: string, userKey: string, pbxId: string) {
    userKey && loggerInstance.setContext(RESTRICTED_LOGGER_KEYS.LS_USER_KEY, userKey)
    accountKey && loggerInstance.setContext(RESTRICTED_LOGGER_KEYS.LS_ACCOUNT_KEY, accountKey)
    pbxId && loggerInstance.setContext(RESTRICTED_LOGGER_KEYS.LS_PBX_ID, pbxId)
  }

  setSubAppContext(subAppName: string) {
    subAppName && loggerInstance.setContext(RESTRICTED_LOGGER_KEYS.LS_SUB_COMPONENT, subAppName)
  }

  setContext(property: string, value: any) {
    if (!this.isRestrictedKey(property)) {
      loggerInstance.setContext(property, value)
    } else {
      throw new Error(`Property name, ${property}, is a restricted key`)
    }
  }

  logMeasure(measure: Measure) {
    const measureObject = {
      ...measure.details,
      measure: measure.measureName,
      duration: measure.duration,
    }
    loggerInstance.log(measureObject)
  }

  private isRestrictedKey(property: string) {
    return Object.keys(RESTRICTED_LOGGER_KEYS)
      .map((key) => RESTRICTED_LOGGER_KEYS[key])
      .includes(property)
  }
}

const gtaLoggerInstance = Object.freeze(new GTALogger())

export default gtaLoggerInstance
